export interface GateGroup {
  readonly label: string;
  readonly gates: readonly string[];
}

export type AirportGateGroups = Record<string, readonly GateGroup[]>;

/**
 * Generate a list of gate IDs like "A01", "A02", …, skipping specified numbers.
 * Numbers are zero-padded to 2 digits to match Delta FIDS gate naming.
 */
export function gateRange(
  prefix: string,
  start: number,
  end: number,
  skip: readonly number[] = [],
): readonly string[] {
  const gates: string[] = [];
  for (let i = start; i <= end; i++) {
    if (!skip.includes(i)) {
      gates.push(`${prefix}${String(i).padStart(2, "0")}`);
    }
  }
  return gates;
}

/**
 * Normalize a gate name to its base form for concourse matching.
 * Strips trailing letter suffixes (e.g., "D08A" → "D08", "T01A" → "T01")
 * so suffix variants match their base gate number in the concourse filter.
 */
export function normalizeGate(gate: string): string {
  return gate.replace(/([A-Z]\d{2,})[A-Z]$/i, "$1");
}

export const AIRPORT_GATE_GROUPS: AirportGateGroups = {
  ATL: [
    {
      label: "T",
      gates: gateRange("T", 1, 8),
    },
    {
      label: "A South",
      gates: gateRange("A", 1, 18, [8, 13, 14]),
    },
    {
      label: "A North",
      gates: gateRange("A", 19, 34, [22, 23]),
    },
    {
      label: "B South",
      gates: gateRange("B", 1, 18, [8, 15]),
    },
    {
      label: "B North",
      gates: gateRange("B", 19, 36, [30, 35]),
    },
  ],
};
